import axios from 'axios';
import { apiHost } from 'utils/config';

export const SiteType = Object.freeze({
  SURENOTIFY: 0,
  NEWSLEOPARD: 1,
  OFFICIAL: 2,
  BLOG: 3
});

export class SiteNotificationService {
  async getOfficialNotifications() {
    const q = new URLSearchParams({ site: SiteType.OFFICIAL });
    const res = await axios.get(`${apiHost}/site-notifications?${q.toString()}`);
    return res.data;
  }
}

export const siteNotificationService = new SiteNotificationService();
